// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet aanvragen-public API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { AanvragenMuterenStartMutatieDto } from '../model/aanvragenMuterenStartMutatieDto.ts';

import type { AanvragenMuterenStartMutatieMutatieDto } from '../model/aanvragenMuterenStartMutatieMutatieDto.ts';

import type { MuterenGetMogelijkeMutatieActiesParams } from '../model/muterenGetMogelijkeMutatieActiesParams.ts';

import type { MuterenStartMutatieViaOfferteParams } from '../model/muterenStartMutatieViaOfferteParams.ts';

import type { Result1OfAanvragenMuterenMutatieActiesDto } from '../model/result1OfAanvragenMuterenMutatieActiesDto.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Start een mutatie
 */
export const muterenStart = (
  polisnummerpakket: MaybeRefOrGetter<string | undefined | null>,
  aanvragenMuterenStartMutatieMutatieDto?: MaybeRefOrGetter<AanvragenMuterenStartMutatieMutatieDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  polisnummerpakket = toValue(polisnummerpakket);
  aanvragenMuterenStartMutatieMutatieDto = toValue(aanvragenMuterenStartMutatieMutatieDto);

  return customInstance<AanvragenMuterenStartMutatieDto>(
    {
      url: `/api/v1/muteren/${polisnummerpakket}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: aanvragenMuterenStartMutatieMutatieDto,
      signal,
    },
    options,
  );
};

export const getMuterenStartMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof muterenStart>>,
    TError,
    MuterenStartMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof muterenStart>>,
  TError,
  MuterenStartMutationVariables,
  TContext
> => {
  const mutationKey = ['muterenStart'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof muterenStart>>,
    MuterenStartMutationVariables
  > = (props) => {
    const { polisnummerpakket, data } = props ?? {};

    return muterenStart(polisnummerpakket, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MuterenStartMutationResult = NonNullable<Awaited<ReturnType<typeof muterenStart>>>;
export type MuterenStartMutationBody = AanvragenMuterenStartMutatieMutatieDto | undefined;
export type MuterenStartMutationError = ErrorType<void>;
export type MuterenStartMutationVariables = {
  polisnummerpakket: string | undefined | null;
  data?: AanvragenMuterenStartMutatieMutatieDto;
};

/**
 * @summary Start een mutatie
 */
export const useMuterenStart = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof muterenStart>>,
      TError,
      MuterenStartMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof muterenStart>>,
  TError,
  MuterenStartMutationVariables,
  TContext
> => {
  return useMutation(getMuterenStartMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Muteren.MutatieStarten</li></ul>
 * @summary Start een mutatie via een offerte
 */
export const muterenStartMutatieViaOfferte = (
  polisnummerPakket: MaybeRefOrGetter<string | undefined | null>,
  params?: MaybeRefOrGetter<MuterenStartMutatieViaOfferteParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  polisnummerPakket = toValue(polisnummerPakket);
  params = toValue(params);

  return customInstance<void>(
    { url: `/api/v1/muteren/${polisnummerPakket}/viaofferte`, method: 'POST', params, signal },
    options,
  );
};

export const getMuterenStartMutatieViaOfferteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof muterenStartMutatieViaOfferte>>,
    TError,
    MuterenStartMutatieViaOfferteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof muterenStartMutatieViaOfferte>>,
  TError,
  MuterenStartMutatieViaOfferteMutationVariables,
  TContext
> => {
  const mutationKey = ['muterenStartMutatieViaOfferte'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof muterenStartMutatieViaOfferte>>,
    MuterenStartMutatieViaOfferteMutationVariables
  > = (props) => {
    const { polisnummerPakket, params } = props ?? {};

    return muterenStartMutatieViaOfferte(polisnummerPakket, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MuterenStartMutatieViaOfferteMutationResult = NonNullable<
  Awaited<ReturnType<typeof muterenStartMutatieViaOfferte>>
>;

export type MuterenStartMutatieViaOfferteMutationError = ErrorType<void>;
export type MuterenStartMutatieViaOfferteMutationVariables = {
  polisnummerPakket: string | undefined | null;
  params?: MuterenStartMutatieViaOfferteParams;
};

/**
 * @summary Start een mutatie via een offerte
 */
export const useMuterenStartMutatieViaOfferte = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof muterenStartMutatieViaOfferte>>,
      TError,
      MuterenStartMutatieViaOfferteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof muterenStartMutatieViaOfferte>>,
  TError,
  MuterenStartMutatieViaOfferteMutationVariables,
  TContext
> => {
  return useMutation(getMuterenStartMutatieViaOfferteMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Muteren.ProductMuteren</li></ul>
 * @summary Muteert een product van de offerte.
 */
export const muterenProductMuteren = (
  offertenummer: MaybeRefOrGetter<string | undefined | null>,
  offerteproductId: MaybeRefOrGetter<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  offertenummer = toValue(offertenummer);
  offerteproductId = toValue(offerteproductId);

  return customInstance<void>(
    { url: `/api/v1/muteren/${offertenummer}/${offerteproductId}`, method: 'POST', signal },
    options,
  );
};

export const getMuterenProductMuterenMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof muterenProductMuteren>>,
    TError,
    MuterenProductMuterenMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof muterenProductMuteren>>,
  TError,
  MuterenProductMuterenMutationVariables,
  TContext
> => {
  const mutationKey = ['muterenProductMuteren'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof muterenProductMuteren>>,
    MuterenProductMuterenMutationVariables
  > = (props) => {
    const { offertenummer, offerteproductId } = props ?? {};

    return muterenProductMuteren(offertenummer, offerteproductId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MuterenProductMuterenMutationResult = NonNullable<
  Awaited<ReturnType<typeof muterenProductMuteren>>
>;

export type MuterenProductMuterenMutationError = ErrorType<void>;
export type MuterenProductMuterenMutationVariables = {
  offertenummer: string | undefined | null;
  offerteproductId: number | undefined | null;
};

/**
 * @summary Muteert een product van de offerte.
 */
export const useMuterenProductMuteren = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof muterenProductMuteren>>,
      TError,
      MuterenProductMuterenMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof muterenProductMuteren>>,
  TError,
  MuterenProductMuterenMutationVariables,
  TContext
> => {
  return useMutation(getMuterenProductMuterenMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieInzien</li></ul>
 * @summary Haalt mutatie-acties op voor een pakketpolisnummer of contractnummer en relatienummer
 */
export const muterenGetMogelijkeMutatieActies = (
  pakketpolisnummer: MaybeRefOrGetter<string | undefined | null>,
  params?: MaybeRefOrGetter<MuterenGetMogelijkeMutatieActiesParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  pakketpolisnummer = toValue(pakketpolisnummer);
  params = toValue(params);

  return customInstance<Result1OfAanvragenMuterenMutatieActiesDto>(
    { url: `/api/v1/muteren/${pakketpolisnummer}/acties`, method: 'GET', params, signal },
    options,
  );
};

export const getMuterenGetMogelijkeMutatieActiesQueryKey = (
  pakketpolisnummer: MaybeRefOrGetter<string | undefined | null>,
  params?: MaybeRefOrGetter<MuterenGetMogelijkeMutatieActiesParams>,
) => {
  return [
    'api',
    'v1',
    'muteren',
    pakketpolisnummer,
    'acties',
    ...(params ? [params] : []),
  ] as const;
};

export const getMuterenGetMogelijkeMutatieActiesQueryOptions = <
  TData = Awaited<ReturnType<typeof muterenGetMogelijkeMutatieActies>>,
  TError = ErrorType<void>,
>(
  pakketpolisnummer: MaybeRefOrGetter<string | undefined | null>,
  params?: MaybeRefOrGetter<MuterenGetMogelijkeMutatieActiesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof muterenGetMogelijkeMutatieActies>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getMuterenGetMogelijkeMutatieActiesQueryKey(pakketpolisnummer, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof muterenGetMogelijkeMutatieActies>>> = ({
    signal,
  }) => muterenGetMogelijkeMutatieActies(pakketpolisnummer, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () => toValue(pakketpolisnummer) !== null && toValue(pakketpolisnummer) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof muterenGetMogelijkeMutatieActies>>, TError, TData>;
};

export type MuterenGetMogelijkeMutatieActiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof muterenGetMogelijkeMutatieActies>>
>;
export type MuterenGetMogelijkeMutatieActiesQueryError = ErrorType<void>;

/**
 * @summary Haalt mutatie-acties op voor een pakketpolisnummer of contractnummer en relatienummer
 */

export function useMuterenGetMogelijkeMutatieActies<
  TData = Awaited<ReturnType<typeof muterenGetMogelijkeMutatieActies>>,
  TError = ErrorType<void>,
>(
  pakketpolisnummer: MaybeRefOrGetter<string | undefined | null>,
  params?: MaybeRefOrGetter<MuterenGetMogelijkeMutatieActiesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof muterenGetMogelijkeMutatieActies>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMuterenGetMogelijkeMutatieActiesQueryOptions(
    pakketpolisnummer,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Muteren.ProductMuteren</li></ul>
 * @summary Maakt een mutatie of een royement ongedaan.
 */
export const muterenMaakMutatieOngedaanOpProduct = (
  offertenummer: MaybeRefOrGetter<string | undefined | null>,
  offerteproductId: MaybeRefOrGetter<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  offertenummer = toValue(offertenummer);
  offerteproductId = toValue(offerteproductId);

  return customInstance<void>(
    {
      url: `/api/v1/muteren/${offertenummer}/${offerteproductId}/ongedaan-maken`,
      method: 'POST',
      signal,
    },
    options,
  );
};

export const getMuterenMaakMutatieOngedaanOpProductMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof muterenMaakMutatieOngedaanOpProduct>>,
    TError,
    MuterenMaakMutatieOngedaanOpProductMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof muterenMaakMutatieOngedaanOpProduct>>,
  TError,
  MuterenMaakMutatieOngedaanOpProductMutationVariables,
  TContext
> => {
  const mutationKey = ['muterenMaakMutatieOngedaanOpProduct'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof muterenMaakMutatieOngedaanOpProduct>>,
    MuterenMaakMutatieOngedaanOpProductMutationVariables
  > = (props) => {
    const { offertenummer, offerteproductId } = props ?? {};

    return muterenMaakMutatieOngedaanOpProduct(offertenummer, offerteproductId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MuterenMaakMutatieOngedaanOpProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof muterenMaakMutatieOngedaanOpProduct>>
>;

export type MuterenMaakMutatieOngedaanOpProductMutationError = ErrorType<void>;
export type MuterenMaakMutatieOngedaanOpProductMutationVariables = {
  offertenummer: string | undefined | null;
  offerteproductId: number | undefined | null;
};

/**
 * @summary Maakt een mutatie of een royement ongedaan.
 */
export const useMuterenMaakMutatieOngedaanOpProduct = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof muterenMaakMutatieOngedaanOpProduct>>,
      TError,
      MuterenMaakMutatieOngedaanOpProductMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof muterenMaakMutatieOngedaanOpProduct>>,
  TError,
  MuterenMaakMutatieOngedaanOpProductMutationVariables,
  TContext
> => {
  return useMutation(getMuterenMaakMutatieOngedaanOpProductMutationOptions(options), queryClient);
};
